/** GxPrintPage: one A4 portrait sheet of a printed pack (title, content, page footer). Wrap the sheets in `GxPrintDesk`; its style is `print.css`. */
import type { ReactNode } from "react";
import "./print.css";

export const GxPrintDesk = ({ children, testId }: { readonly children: ReactNode; readonly testId?: string }) => <div className="gx-printdesk" data-testid={testId}>{children}</div>;

export function GxPrintPage({ title, eyebrow, footer, page, of, children, testId }: {
  readonly title: string; readonly eyebrow?: string; readonly footer: string; readonly page: number; readonly of: number; readonly children: ReactNode; readonly testId?: string;
}) {
  return (
    <section className="gx-printpage" data-testid={testId} aria-label={title}>
      <header className="gx-printpage-h"><div>{eyebrow === undefined ? null : <div className="gx-eyebrow">{eyebrow}</div>}<h2 className="gx-h2">{title}</h2></div></header>
      {children}
      <footer className="gx-printpage-f"><span>{footer}</span><span>Page {page} of {of}</span></footer>
    </section>
  );
}
